import { useEffect } from 'react';
import { setDateTimePickerElementPattern } from '../../../helpers/ElementHelpers';

export const usePickerElementPattern = () => {
    useEffect(() => {
        setDateTimePickerElementPattern("date-picker", "k-input-inner", "[0-9]*");
    }, []);
};
